import { ConditionOperatorEnum, ResourceType } from '@repo/api-gw-sdk';

import {
  apps,
  resourceId,
  resourceType,
  vaults,
} from '@/components/queryBuilder/properties';
import { ResourcesSelector } from '@/components/resourcesSelection/resourcesSelector';
import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';

export const IntegrationResourcesSelectorWrapper = ({
  vaultId,
  initialResourcesIds,
  selectedResourcesIds,
  addResource,
  removeResource,
  disabledDeletion,
  disabled,
}: {
  vaultId: string | undefined;
  initialResourcesIds: string[];
  selectedResourcesIds: string[];
  addResource: (providerResourceId: string) => void;
  removeResource: (providerResourceId: string) => void;
  disabledDeletion?: boolean;
  disabled?: boolean;
}) => {
  const dal = useDAL();

  // Database resource types that integrations can use
  const databaseResourceTypes = [ResourceType.AwsRds, ResourceType.AwsDynamoDb];

  const dbConditions = [
    {
      property: resourceType.name,
      operator: ConditionOperatorEnum.In,
      value: databaseResourceTypes,
    },
    {
      property: apps.name,
      operator: ConditionOperatorEnum.ContainsAnyOf,
      value: ['PostgreSQL', 'SQLServer', 'MySQL'],
    },
  ];

  const conditions = [
    createCombineCondition(dbConditions, ConditionOperatorEnum.Or),
  ];

  if (vaultId) {
    conditions.push({
      property: vaults.name,
      operator: ConditionOperatorEnum.ContainsAnyOf,
      value: [vaultId],
    });
  }

  const { data: resourcesData } = dal.inventory.useListResourceIdentifiers(
    createCombineCondition(conditions, ConditionOperatorEnum.And)
  );

  const { data: initialResourcesData } =
    dal.inventory.useListResourceIdentifiers(
      createCombineCondition(
        [
          {
            property: resourceId.name,
            operator: ConditionOperatorEnum.In,
            value: initialResourcesIds,
          },
        ],
        ConditionOperatorEnum.Or
      )
    );

  const allResources = (resourcesData?.resources ?? []).concat(
    initialResourcesData?.resources ?? []
  );

  return (
    <ResourcesSelector
      freeTextAdd={false}
      disabled={disabled}
      disabledDeletion={disabledDeletion}
      initialResourcesIds={initialResourcesIds}
      allResources={allResources}
      addResource={addResource}
      description=''
      label=''
      resources={selectedResourcesIds}
      removeResource={removeResource}
    />
  );
};
